import React, { ReactNode } from 'react';
import { Panel } from '@appkit4/react-components/panel';

interface PanelProps {
  config: {
    title: string;
    brightnessOnHover: number;
    imageUrl: string;
  };
  children: ReactNode;
}

const PanelSample: React.FC<PanelProps> = ({ config, children }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Panel
      className="ap-panel"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ filter: isHovered ? `brightness(${config.brightnessOnHover}%)` : 'brightness(100%)', borderRadius: '10px', backgroundColor: '#415385' }}
    >
      <div className="panel-content" style={{ display: 'flex', alignItems: 'flex-start',  backgroundColor: '#415385', padding: '10px' }}>
        <div className="panel-left" style={{ flex: 4, marginRight: '10px' }}>
          <h2 className="panel-title" style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '15px', marginTop: '10px' }}>{config.title}</h2>
          <div className="panel-text">
            {children}
          </div>
        </div>
      </div>
    </Panel>
  );  
};

export default PanelSample;